import { render, staticRenderFns } from "./index.vue?vue&type=template&id=db368f74&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=db368f74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db368f74",
  null
  
)

export default component.exports